// App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Appbar from "./components/AppBar";
import MemberForm from "./pages/public/MemberForm";
import Footer from "./components/Footer";
import StateCards from "./pages/public/StateGoverningBody/StateCards";
import AdminLogin from "./pages/admin/AdminLogin";
import HomePage from "./pages/public/HomePage/HomePage";
import AboutUs from "./pages/public/AboutUs/AboutUs";
import Directors from "./pages/public/Directors/Directors";
import ContactUs from "./pages/public/ContactUs/ContactUs";
import { getAdminAuth } from "./Services";
import AdminDashboard from "./pages/admin/AdminDashboard/AdminDashboard";
import SearchMember from "./pages/public/MemberSearch/SearchMember";
import PublicGallery from "./pages/public/Gallery/Gallery";
import PrivacyPolicy from "./pages/public/PrivacyPolicy/PrivacyPolicy";
import RefundPolicy from "./pages/public/RefundPolicy/RefundPolicy";
import TermsAndConditions from "./pages/public/Terms&Conditions/Terms&Conditions";
import StatePage from "./pages/public/StateGoverningBody/StatePage";
import EarlyMemberForm from "./pages/public/EarlyMember/EarlyMemberForm";
import BlacklistedMembers from "./pages/public/BlacklistedMembers/BlacklistedMembers";

function App() {
  return (
    <div>
      <Appbar />
      <Routes>
        {/*Admin Path*/}
        <Route
          path="/admin-login"
          element={
            getAdminAuth() ? (
              <Navigate to="/admin-dashboard" replace />
            ) : (
              <AdminLogin />
            )
          }
        />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />

        {/*Public Path*/}
        <Route path="/" element={<HomePage />} />
        <Route path="/About-Us" element={<AboutUs />} />
        <Route path="/Directors" element={<Directors />} />
        <Route path="/State-Governing-Body" element={<StateCards />} />
        <Route path="/Membership" element={<MemberForm />} />
        <Route path="/Gallery" element={<PublicGallery />} />
        <Route path="/Contact-Us" element={<ContactUs />} />

        <Route path="/States" element={<StatePage />} />

        <Route path="/search-member" element={<SearchMember />} />
        <Route path="Privacy-Policy" element={<PrivacyPolicy />} />
        <Route path="/Refund-Policy" element={<RefundPolicy />} />
        <Route path="/Terms-and-Conditions" element={<TermsAndConditions />} />

        <Route path="/Early-Member-Form" element={<EarlyMemberForm />} />
        <Route path="/Blacklisted-Members" element={<BlacklistedMembers />} />
        {/* other pages later */}
      </Routes>
      <Footer />
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;
